import type { Mutation } from '@tanstack/react-query';

/**
 * Mutations excluded from the offline modifications history.
 * Reset is a server action, not field sync.
 */
export const OFFLINE_HISTORY_HIDDEN_MUTATION_KEYS = new Set(['resetAnalysis']);

/** Shown in the control center when paused, succeeded, or failed — not while in-flight. */
const OFFLINE_HISTORY_SYNC_MUTATION_KEYS = new Set([
  'updateMeasure',
  'uploadCropPicture',
]);

type MutationLike = Pick<Mutation<unknown, unknown, unknown>, 'options' | 'state'>;

export function isVisibleInOfflineHistory(
  mutationKey: readonly unknown[] | undefined,
  mutation?: MutationLike
): boolean {
  const key = mutationKey?.[0];
  if (typeof key !== 'string') {
    return true;
  }

  if (OFFLINE_HISTORY_HIDDEN_MUTATION_KEYS.has(key)) {
    return false;
  }

  if (OFFLINE_HISTORY_SYNC_MUTATION_KEYS.has(key)) {
    if (!mutation) {
      return false;
    }
    if (mutation.state.isPaused) {
      return true;
    }
    return (
      mutation.state.status === 'success' || mutation.state.status === 'error'
    );
  }

  return true;
}
